export const isSameDay = (date1, date2) => {
  const isSameYear = date1.getFullYear() === date2.getFullYear();
  const isSameMonth = date1.getMonth() === date2.getMonth();
  const isSameDate = date1.getDate() === date2.getDate();

  return isSameDate && isSameMonth && isSameYear;
};

export const isToday = (date) => isSameDay(date, new Date());
